// Smart-capitalization helpers.
//
// Rule (Option A): if the input already contains ANY uppercase letter, the user clearly
// typed it intentionally — preserve it as-is. Only auto-capitalize when the input is
// entirely lowercase (no upper-case letters anywhere).
//
// This keeps acronyms, plate numbers, product names, road IDs like "I-95",
// "BMW M3", "USDOT-1234", "DA test", "HE LEFT THE SCENE" exactly as typed.

const hasUppercase = (str) => /[A-Z]/.test(str);

export const toProperCase = (str) => {
  if (!str || typeof str !== 'string') return str;
  if (hasUppercase(str)) return str;
  return str.replace(/\b\w+/g, w => w.charAt(0).toUpperCase() + w.slice(1));
};

export const toSentenceCase = (str) => {
  if (!str || typeof str !== 'string') return str;
  if (hasUppercase(str)) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};
